import { ILoanSummaryDashboardClosedLoanTypeSummary } from '@apply/api/src/api/loanApi';
import { ILoanTypeClosedByMonthTotals } from '../interfaces/ILoanTypeClosedByMonthTotals';

export function closedLoanTypeByMonthTotals(
    dataSource: ILoanSummaryDashboardClosedLoanTypeSummary[] | undefined
): ILoanTypeClosedByMonthTotals[] {
    if (!dataSource) return [];

    const monthToDateKey = 'MonthToDate';
    const t12Key = 'T-12';

    // Initialize map with MonthToDate and T-12 buckets
    const map = new Map<string, ILoanTypeClosedByMonthTotals>();
    map.set(monthToDateKey, { month: monthToDateKey, committed: 0, funded: 0, number: 0 });
    map.set(t12Key, { month: t12Key, committed: 0, funded: 0, number: 0 });

    // Aggregate all rows
    dataSource.forEach((row) => {
        // --- MonthToDate ---
        const mtdAgg = map.get(monthToDateKey)!;
        mtdAgg.committed += row.monthToDate.committedAmount ?? 0;
        mtdAgg.funded += row.monthToDate.fundedAmount ?? 0;
        mtdAgg.number += row.monthToDate.number ?? 0;

        // --- Monthly Details ---
        row.monthlyDetails.forEach((md) => {
            // Create month bucket if missing
            if (!map.has(md.month)) {
                map.set(md.month, {
                    month: md.month,
                    committed: 0,
                    funded: 0,
                    number: 0,
                });
            }

            const agg = map.get(md.month)!;
            agg.committed += md.counts.committedAmount ?? 0;
            agg.number += md.counts.number ?? 0;
            agg.funded += md.counts.fundedAmount ?? 0;

            // --- T-12 bucket ---
            if (md.isT12) {
                const t12 = map.get(t12Key)!;
                t12.committed += md.counts.committedAmount ?? 0;
                t12.number += md.counts.number ?? 0;
                t12.funded += md.counts.fundedAmount ?? 0;
            }
        });
    });

    // Convert map → array
    const result = Array.from(map.values());

    // Sort output: MonthToDate → T-12 → all months alphabetically
    return result.sort((a, b) => {
        if (a.month === monthToDateKey) return -1;
        if (b.month === monthToDateKey) return 1;
        if (a.month === t12Key) return -1;
        if (b.month === t12Key) return 1;
        return a.month.localeCompare(b.month);
    });
}
